import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

/** M14 · Integrações (M14.7): abas Conectores, Webhooks, API e MCP. */
const carregar0 = () => import('./Conectores');
const carregar1 = () => import('./Webhooks');
const carregar2 = () => import('./Api');
const carregar3 = () => import('./Mcp');
const carregar4 = () => import('./comum');

const Conectores = telaSobDemanda(carregar0, 'Conectores');
const Webhooks = telaSobDemanda(carregar1, 'Webhooks');
const Api = telaSobDemanda(carregar2, 'Api');
const Mcp = telaSobDemanda(carregar3, 'Mcp');
const AcaoNovo = acaoSobDemanda(carregar4, 'AcaoNovo');

export const modulo: ModuloWeb = {
  slug: 'integracoes',
  menu: 'integracoes',
  dicionario,
  abas: [
    { rotulo: 'abas.conectores', caminho: 'conectores', elemento: <Conectores />, ordem: 1 },
    { rotulo: 'abas.webhooks', caminho: 'webhooks', elemento: <Webhooks />, Acao: () => <AcaoNovo rotulo="acoes.novaAssinatura" />, ordem: 2 },
    { rotulo: 'abas.api', caminho: 'api', elemento: <Api />, Acao: () => <AcaoNovo rotulo="acoes.novaChave" />, ordem: 3 },
    { rotulo: 'abas.mcp', caminho: 'mcp', elemento: <Mcp />, ordem: 4 },
  ],
};
